module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"showActivity":"Show activity"},"de":{"showActivity":"Aktivität anzeigen"},"fr":{"showActivity":"Afficher l\u0027activité"},"it":{"showActivity":"Mostra attività"}}')
  delete Component.options._Ctor
}
